import { callAjax } from "../../../../assets/js/helpers";

export class BookingAjaxes {
  public async getDisabledDays() {
    const formData = new FormData();

    formData.append("action", "getDisabledDays");
    formData.append("post_id", `${jsData.post_id}`);
    formData.append("nonce", `${jsData.nonce}`);

    return callAjax({
      body: formData,
      method: "POST",
    }).then((res) => res.json());
  }

  public async getBookedDays() {
    const formData = new FormData();

    formData.append("action", "getBookedDays");
    formData.append("nonce", `${jsData.nonce}`);
    formData.append("post_id", `${jsData.post_id}`);

    return callAjax({
      body: formData,
      method: "POST",
    }).then((res) => res.json());
  }

  public async getBookingDays() {
    const formData = new FormData();

    formData.append("action", "getBookingDays");
    formData.append("nonce", `${jsData.nonce}`);
    formData.append("post_id", `${jsData.post_id}`);

    return callAjax({
      body: formData,
      method: "POST",
    }).then((res) => res.json());
  }

  /**
   *
   * @param dateStart y-m-d
   * @param dateEnd y-m-d
   * @returns
   */
  public async getAvailableBoatsForDates(dateStart: string, dateEnd: string) {
    const formData = new FormData();

    formData.append("action", "getAvailableBoatsForDates");
    formData.append("booked_date_start", dateStart);
    formData.append("booked_date_end", dateEnd);
    formData.append("nonce", `${jsData.nonce}`);

    return callAjax({
      body: formData,
      method: "POST",
    }).then((res) => res.json());
  }
}
